import { render } from "./customerActivateLayout.vue?vue&type=template&id=72c24bd3&scoped=true&ts=true"
import script from "./customerActivateLayout.vue?vue&type=script&lang=ts"
export * from "./customerActivateLayout.vue?vue&type=script&lang=ts"

import "./customerActivateLayout.vue?vue&type=style&index=0&id=72c24bd3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72c24bd3"]])

export default __exports__